/** @format */

import { useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTES } from '../../constant/routes';
import AuthLayout from '../../components/layouts/AuthLayout';
import logo from '../../assets/llb360.png';
import { ResetPasswordForm } from '../../components/ui/ResetPasswordForm';

const isValidEmail = (email: string) =>
	/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const ResetPasswordPage: React.FC = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const email = searchParams.get('email');

	useEffect(() => {
		if (!email || !isValidEmail(email)) {
			navigate(ROUTES.FORGOT_PASSWORD, { replace: true });
		}
	}, [email, navigate]);

	return (
		<AuthLayout>
			<div className='authContainer'>
				<Link
					to={ROUTES.RESET_PASSWORD}
					className='flex justify-center w-full mb-4'>
					<img
						src={logo}
						alt='LLB360 Logo'
						className='w-28'
						loading='lazy'
					/>
				</Link>
				<h2 className='authSubtitle'>Reset Password</h2>
				{email && isValidEmail(email) && (
					<ResetPasswordForm onSuccess={() => navigate(ROUTES.LOGIN)} />
				)}
			</div>
		</AuthLayout>
	);
};

export default ResetPasswordPage;
